import BaseHttp from '../../../plugins/baseHttp';

const getIndicators = ({ begin_date, end_date, },) => {
  return BaseHttp.get(`/franchises/summary?created_at>=${begin_date}&created_at<=${end_date}`,);
};


const handleError = (error,) => {
  return BaseHttp.handleError(error,);
};

export default {
  getIndicators,
  handleError,
};
